import React from 'react';
import { CheckIcon } from 'lucide-react';
import { INSIDE_CLOSING_BOTTOM, INSIDE_CLOSING_TOP, INSIDE_HEADLINE, MAIN_MOCKUP, MOCKUP_ALT, insideGroups } from '../data/poolContent';
export function IncludesSection() {
  return <section className="w-full bg-abyss-950 py-14 sm:py-20" aria-labelledby="includes-title" data-id="element-184" data-mp="28xyc1iqa8e15">
      <div className="mx-auto max-w-6xl px-5" data-id="element-185" data-mp="23zwvb4gbwqsu">
        <div className="grid items-start gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14" data-id="element-186" data-mp="1z13izfcs35u9">
          <div className="text-center lg:sticky lg:top-8 lg:text-left" data-id="element-187" data-mp="1uzrnwub4xseo">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-aqua" data-id="element-188" data-mp="1uygm30192uq7">
              Main guide — 90 pages
            </p>
            <h2 id="includes-title" className="mt-3 font-display text-[2.1rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.8rem]" data-id="element-189" data-mp="1l23tk5hfymx1">
              {INSIDE_HEADLINE}
            </h2>
            <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto mt-8 w-full max-w-sm lg:mx-0" width={1199} height={1312} loading="lazy" data-id="element-190" data-mp="3fgwmfwqxwzla" />
          </div>

          <div className="grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-191" data-mp="3kiue0zq788v6">
            {insideGroups.map(g => <div key={g.group} data-id="element-192" data-mp="3ph5lj3t0u7a8">
                <h3 className="border-b border-abyss-600 pb-2.5 font-display text-[1.2rem] font-bold uppercase tracking-[0.06em] text-pool-light" data-id="element-193" data-mp="3pigtlfti2175">
                  {g.group}
                </h3>
                <ul className="mt-3 space-y-2" data-id="element-194" data-mp="lznhz8ka7mfm">
                  {g.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-195" data-mp="7b9f4xmv7xz2">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" strokeWidth={2.5} aria-hidden="true" data-id="element-196" data-mp="calyv9ifwoxf" />
                      <span className="text-[14px] leading-snug text-frost-100" data-id="element-197" data-mp="14rq42zfozux9">{item}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <p className="mx-auto mt-14 max-w-3xl border-t border-abyss-600 pt-10 text-center font-display text-[1.7rem] font-bold uppercase leading-tight text-frost-50 sm:text-[2.2rem]" data-id="element-198" data-mp="19pn7qi1rj3ng">
          {INSIDE_CLOSING_TOP}
          <span className="block text-aqua" data-id="element-199" data-mp="10ne3ub1028j1">{INSIDE_CLOSING_BOTTOM}</span>
        </p>
      </div>
    </section>;
}